import { render, staticRenderFns } from "./NotificationData.vue?vue&type=template&id=4eff0a16&scoped=true&"
import script from "./NotificationData.vue?vue&type=script&lang=js&"
export * from "./NotificationData.vue?vue&type=script&lang=js&"
import style0 from "./NotificationData.vue?vue&type=style&index=0&id=4eff0a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff0a16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
